module.exports = __webpack_public_path__ + "static/media/goodtimes-small.169a9b3a.png";